import { api } from '../lib/gapApi';

export const getPainPoints = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/pain-points`);
  return response.data;
};

export const getRecommendations = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/recommendations`);
  return response.data;
};

export const getBusinessImpacts = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/business-impact`);
  return response.data;
};

export const getOverallPainPointSummary = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/pain-points/summary`);
  return response.data;
};

export const getPainPointDeepDive = async (analysisId, painPointId) => {
  const response = await api.get(`/analysis/${analysisId}/pain-points/${painPointId}/deep-dive`);
  return response.data;
};
